import type { CliChoice } from "@/components/onboarding/cli-chooser-phases";
import type { DetectedOS } from "@/lib/detect-os";
import type { RuntimeSetupActionKind } from "./post-demo-runtime-choice-list";

/**
 * "background" runs the allowlisted command as a hidden child process,
 * "guided" stages it in Denker's Terminal, "copy" leaves it to the user.
 */
export type RuntimeSetupMode = "background" | "guided" | "copy";

/** How Denker carries out one setup action; identical on macOS and Windows. */
export function runtimeSetupMode({
  os,
  tauri,
  cli,
  kind,
  updateSupported,
}: {
  os: DetectedOS | null;
  tauri: boolean;
  cli: CliChoice;
  kind: RuntimeSetupActionKind;
  /** Native allowlist verdict for this executable; only read for updates. */
  updateSupported: boolean;
}): RuntimeSetupMode {
  if (!tauri || (os !== "macos" && os !== "windows")) return "copy";
  if (kind === "install") return "background";
  // OpenCode sign-in asks for a provider and an API key in the terminal.
  if (kind === "login") return cli === "opencode" ? "guided" : "background";
  return updateSupported ? "background" : "copy";
}
